<button
  type="button"
  [disabled]="disabled"
  class="thera-header-action-button"
  (click)="onButtonClick($event)"
>
  <ng-content></ng-content>
</button>
